import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom/dist";
// useNavigate
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Select, Spin } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  RotateCcw,
  //   Eye,
} from "feather-icons-react/build/IconComponents";
// import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
// import Swal from "sweetalert2";

const FixedIncentives = () => {
  const [dataLoading, setDataLoading] = useState(false);
  console.log(setDataLoading);
  //   const navigate = useNavigate();
  const [DeptList, setDeptList] = useState([]);
  const [SelectedDeptId, setSelectedDeptId] = useState([0]);
  const [selectedPayPeriod, setSelectedPayPeriod] = useState({
    value: 0,
    label: "All",
  });
  const [PayPeriodlist, setPayPeriodlist] = useState([]);
  const [branchesList, setBranchesList] = useState([]);
  const [SelectedBranchId, setSelectedBranchId] = useState([0]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [employeesList, setEmployeesList] = useState([]);
  const [selectedEmpRegId, setSelectedEmpRegId] = useState([0]);

  const [fixedIncentivesData, setFixedIncentivesData] = useState([]);

  const [branchsList, setBranchsList] = useState([]);
  console.log(branchsList, "branchsListbranchsListbranchsList");

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const columns = [
   {
  title: "Employee",
  dataIndex: "Employee",
  sorter: (a, b) => a.Employee.localeCompare(b.Employee),
  render: (text) => (
    <span title={text}>
      {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
    </span>
  ),
},
    {
      title: "Emp Code",
      dataIndex: "Emp Code",
    },
    // {
    //   title: "Pay Period",
    //   dataIndex: "Pay Period",
    // },
    {
      title: "Gross Salary",
      dataIndex: "Gross Salary",
      render: (val) => `₹${val?.toLocaleString("en-IN")}`,
    },
    {
      title: "Fixed Incentive",
      dataIndex: ["Fixed Incentive"],
      render: (val = 0) => (
        <span className="text-primary fw-semibold">
          ₹{val.toLocaleString("en-IN")}
        </span>
      ),
    },

    {
      title: "Updated Gross",
      dataIndex: "Updated Gross",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    {
      title: "PF",
      dataIndex: "PF",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    {
      title: "ESI ",
      dataIndex: "ESI",
      render: (val) => `₹${val.toLocaleString("en-IN")}`,
    },
    {
      title: "Net Pay (₹)",
      dataIndex: "Net Pay (?)",
      render: (val) => (
        <span className="fw-bold text-success">
          ₹{val.toLocaleString("en-IN")}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text) => (
        <span
          className={`badge ${text === "Process" ? "bg-success" : "bg-warning"
            }`}
        >
          {text}
        </span>
      ),
    },
  ];
  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (fixedIncentivesData.length === 0) return;

    const wb = XLSX.utils.book_new();
    const wsData = fixedIncentivesData.map((item, index) => ({
      "S.No": index + 1,
      Employee: item.employee,
      "Emp Code": item.empCode,
      "Monthly Salary": item.monthlySalary,
      "Yearly CTC": item.yearlyCTC,
      Group: item.group,
      "Start Date": formatDate(item.startDate),
      "End Date": formatDate(item.endDate),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Annual CTC");
    XLSX.writeFile(wb, "Employee_Annual_CTC.xlsx");
  };

  const generatePDF = () => {
    if (fixedIncentivesData.length === 0) return;

    const doc = new jsPDF();
    doc.text("Employee Annual CTC Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Employee",
      "Emp Code",
      "Monthly Salary",
      "Yearly CTC",
      "Group",
      "Start Date",
      "End Date",
    ];
    const tableRows = fixedIncentivesData.map((item, index) => [
      index + 1,
      item.employee,
      item.empCode,
      `$${item.monthlySalary.toLocaleString()}`,
      `$${item.yearlyCTC.toLocaleString()}`,
      `$${item.group.toLocaleString()}`,
      formatDate(item.startDate),
      formatDate(item.endDate),
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Employee_Annual_CTC.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      PDF
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");


    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);


  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranchsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Branches");
          }

          const data = await response.json();

          if (data.status) {
            setBranchsList(data.ResultData);
          } else {
            console.error("Invalid Branches response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching Branches:", error.message);
        }
      };
      fetchBranchsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchEmployeesList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/emp/getemployees?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Employees");
          }

          const data = await response.json();

          if (data.status) {
            setEmployeesList(data.ResultData);
          } else {
            console.error("Invalid Employees response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching EmployeesList:", error.message);
        }
      };
      fetchEmployeesList();
    }
  }, [superIdData, tokenData]);
  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranchsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Branches");
          }

          const data = await response.json();

          if (data.status) {
            setBranchesList(data.ResultData);
          } else {
            console.error("Invalid Branches response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching BranchesList:", error.message);
        }
      };
      fetchBranchsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchDeptList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/department/getdepartment?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Dept");
          }

          const data = await response.json();

          if (data.status) {
            setDeptList(data.ResultData);
          } else {
            console.error("Invalid Dept response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching DeptList:", error.message);
        }
      };
      fetchDeptList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchPayPeriodsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/payroll/getPayPeriods?SuperId=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Employees");
          }

          const data = await response.json();

          if (data.status) {
            setPayPeriodlist(data.ResultData);
          } else {
            console.error("Invalid Employees response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching EmployeesList:", error.message);
        }
      };
      fetchPayPeriodsList();
    }
  }, [superIdData, tokenData]);
  // const handleEmpChange = (regid) => {
  //   setSelectedEmpRegId(regid);

  //   console.log("Selected Employee RegId:", regid);
  // };

  const empOptions = [
    { label: "All Employees", value: 0 },
    ...(employeesList?.map((emp) => ({
      label: emp.UserName,
      value: emp.RegId,
    })) || []),
  ];
  const BranchesOptions = [
    { label: "All Branches", value: 0 },
    ...(branchesList?.map((branch) => ({
      label: branch.Name,
      value: branch.branchid,
    })) || []),
  ];
  const DeptOptions = [
    { label: "All Dept", value: 0 },
    ...(DeptList?.map((Dept) => ({
      label: Dept.Name,
      value: Dept.DepartmentId,
    })) || []),
  ];
  const PayperiodOptions = [
    { label: "All PayPeriods", value: 0 },
    ...(PayPeriodlist?.map((period) => ({
      label: period.Name,
      value: period.Id,
    })) || []),
  ];
  const fetchFixedIncentivesData = async (empRegId) => {
    if (!tokenData || !superIdData || !empRegId) return;

    setDataLoading(true);

    try {
      const response = await fetch(
        // `${Payroll_API_BASE_URL}portal/payroll/getctcreport?EmployeeId=${empRegId}`,
        `${Payroll_API_BASE_URL}payroll/payroll/getsalaryreport?SuperId=${superIdData}&EmployeeId=0&BranchId=0&PayPeriodId=0`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${tokenData}`,
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch Fixed Incentives");
      }

      const data = await response.json();

      console.log(data, "ddddddddddddddddddddddddddd");
      if (data.status) {
        setFixedIncentivesData(data.ResultData || []);
      } else {
        console.error("API Error:", data.ErrorMsg);
      }
    } catch (error) {
      console.error("Error fetching Fixed Incentives:", error);
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    if (selectedEmpRegId) {
      fetchFixedIncentivesData(selectedEmpRegId);
    }
  }, [selectedEmpRegId, tokenData, superIdData]);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header m-2">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Fixed Incentives
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your Fixed Incentives here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="PDF"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={handleDownloadExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="Excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
              <div className="">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3 p-0">
              <div className="search-set">
              </div>
              <div className="d-flex align-items-center flex-wrap row-gap-3">
                <h5 className="mb-2  me-2 ">
                  Pay Period: {selectedPayPeriod?.label || "All PayPeriods"}
                </h5>
                <div className="dropdown me-2 pt-3">
                  <div className="input-blocks">
                    <i data-feather="grid" className="info-img" />

                    <Select
                      showSearch
                      labelInValue
                      placeholder="Choose PayPeriod"
                      value={selectedPayPeriod}
                      onChange={(option) => setSelectedPayPeriod(option)}
                      options={PayperiodOptions}
                      style={{ width: 170, height: 37 }}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </div>
                </div>

                <div className="dropdown me-2 pt-3">
                  <div className="input-blocks">
                    <i data-feather="check-circle" className="info-img" />
                    <Select
                      showSearch
                      placeholder="Choose Branch"
                      value={SelectedBranchId}
                      onChange={(val) => setSelectedBranchId(val)}
                      options={BranchesOptions}
                      style={{ width: 170, height: 37 }}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </div>
                </div>
                <div className="dropdown me-2 pt-3">
                  <div className="input-blocks">
                    <i data-feather="check-circle" className="info-img" />
                    <Select
                      showSearch
                      placeholder="Choose Dept"
                      value={SelectedDeptId}
                      onChange={(val) => setSelectedDeptId(val)}
                      options={DeptOptions}
                      style={{ width: 170, height: 37 }}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </div>
                </div>
                <div className="dropdown me-2 pt-3">
                  <div className="input-blocks">
                    <i data-feather="check-circle" className="info-img" />
                    <Select
                      showSearch
                      placeholder="Choose Employee"
                      value={selectedEmpRegId}
                      onChange={(val) => setSelectedEmpRegId(val)}
                      options={empOptions}
                      style={{ width: 170, height: 37 }}
                      filterOption={(input, option) =>
                        option?.label?.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
               <div className="table-responsive">
                {dataLoading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <Table
                    columns={columns}
                    dataSource={fixedIncentivesData}
                    // rowKey={(record, index) => index}
                    rowKey="id"
                    pgno={true}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default FixedIncentives;
